import contentTypes from "astrid-distribution/src/constants/contentTypes";

const artifactContentTypes = {
	WAV: contentTypes.WAV,
	MP3: contentTypes.MP3,
	EPUB: contentTypes.EPUB,
	PDF: contentTypes.PDF,
};

export default artifactContentTypes;
